import React, { useState } from "react";
import PropTypes from "prop-types";

import Button from "ui/Button";

import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import SellIcon from '@mui/icons-material/Sell'; 
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import StorefrontRoundedIcon from '@mui/icons-material/StorefrontRounded';
import EventIcon from '@mui/icons-material/Event';
import { Tooltip } from "@mui/material";

import formattedDate from "utils/formattedDate";

const stateIcons = {
  completed: CheckCircleOutlineIcon,
  initiated: CancelOutlinedIcon,
  pending: PauseCircleOutlineIcon,
}

const stateIconColor = {
  completed: "success",
  initiated: "error",
  pending: "warning",
}

const stateLabels = {
  completed: "Checked In",
  initiated: "Not Checked In",
  pending: "Pending Approval",
}

const generateInitialListItems = (ticket) => [
  {
    label: "Status",
    value: <>{stateLabels[ticket.redeem_state]} {ticket.completed_at && <strong> {formattedDate(ticket.completed_at)}</strong>}</>,    
    icon: stateIcons[ticket.redeem_state],
    iconColor: stateIconColor[ticket.redeem_state],
  },
  { label: "Name", value: ticket.user_name, icon: PersonIcon },
  { label: "Email", value: ticket.user_email, icon: EmailIcon },
];

const generateDetailedListItems = (ticket) => [
  { label: "Order Id", value: ticket.order_id || "N/A", icon: SellIcon },
  { label: "Ticket Reference", value: ticket.uuid, icon: ConfirmationNumberIcon },
  { label: "Date of Purchase", value: formattedDate(ticket.created_at, 'datetime'), icon: EventIcon },
  { label: "Platform", value: ticket.platform, icon: StorefrontRoundedIcon },
];

const Content = ({ ticket }) => {
  const [detailsVisible, setDetailsVisible] = useState(false);

  const listItems = detailsVisible
    ? [...generateInitialListItems(ticket), ...generateDetailedListItems(ticket)]
    : generateInitialListItems(ticket);

  return (
    <>
      <div className="checkin-modal-content">
        {listItems.map((item) => (
          <div key={item.label}>
            <Tooltip title={item.label}>
              <item.icon color={item.iconColor || "warning"}/>
            </Tooltip>
            <p key={item.label}>
              {item.value}
            </p>
          </div>
        ))}
      </div>

      {!detailsVisible && (
        <Button iconColor="warning" smallPadded text onClick={() => setDetailsVisible(true)}>View More Details →</Button>
      )}
    </>
  );
};

Content.propTypes = {
  ticket: PropTypes.object.isRequired,
};

export default Content;
